import { usePathname } from "next/navigation";
import ProductTile from "../components/product-tile";
import { useCountryContext } from "@/providers/country-provider";

const ProductList = () => {
	const products = [
		{
			name: "Efizbo",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/efizbo.jpeg`,
			slug: "efizbo",
		},
		{
			name: "Plunk",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/plunk.png`,
			slug: "plunk",
		},
		{
			name: "Hello Data.ai",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/hello-data-ai.png`,
			slug: "hello-data-ai",
		},
		{
			name: "3Blocks",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/3blocks.png`,
			slug: "3blocks",
		},
		{
			name: "FORTRESS",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/fortress.png`,
			slug: "fortress",
		},
		{
			name: "homebldr.ai",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/homebldr-ai.png`,
			slug: "homebldr-ai",
		},
		{
			name: "Geokey",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/geokey.png`,
			slug: "geokey",
		},
		{
			name: "Camphor Property Search",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/camphor-property-search.png`,
			slug: "camphor-property-search",
		},
		{
			name: "Lighthouse",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/lighthouse.png`,
			slug: "lighthouse",
		},
		{
			name: "Nomad Stays",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/nomad-stays.jpeg`,
			slug: "nomad-stays",
		},
		{
			name: "AppWork",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/appwork.png`,
			slug: "appwork",
		},
		{
			name: "Real Reports",
			logo: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/products/realreports.png`,
			slug: "realreports",
		},
	];

	const pathname = usePathname();
	const { portals, popularTabs } = useCountryContext();
	const isCountryPortalPage = pathname === portals.current.href;
	const productsData = isCountryPortalPage ? popularTabs?.products ?? products : products;

	return (
		<div className="mx-auto mt-8 flex flex-wrap items-center justify-center gap-4 sm:mt-12 sm:gap-6 lg:w-full">
			{productsData.map((product, index) => (
				<ProductTile key={index} {...product} />
			))}
		</div>
	);
};

export default ProductList;
